import { api_GET, api_POST, api_PUT } from './_api';

const inscricaoMunicipal_api = {
    GetList: (filtro) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`InscricaoMunicipais/GetList/${filtro?.cnpj ?? ""}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`InscricaoMunicipais/GetItem/${id}`).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    Post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`InscricaoMunicipais`, model).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    },
    Put: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`InscricaoMunicipais`, model).then(result => {
                resolve(result);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }
}

export default inscricaoMunicipal_api;
